import httpService from "@/utils/request";

const menuService = {
    getMenuList() {
        const url = "/admin/user/subSysOptionMenu?subSysCode=" + process.env.VUE_APP_API_SUB_SYS_CODE;
        return httpService.get(url);
    }
}

export default menuService;
